import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DatePipe } from '@angular/common';
import { DigisubservicesService } from 'src/app/services/digisubservices.service';
import * as XLSX from 'xlsx';
import { RegistrationReportComponent } from '../pages/registration-report/registration-report.component';

@Component({
  selector: 'app-issue-seller-offwise-indetail-repgistration-report',
  templateUrl: './issue-seller-offwise-indetail-repgistration-report.component.html',
  styleUrls: ['./issue-seller-offwise-indetail-repgistration-report.component.scss']
})
export class IssueSellerOffwiseIndetailRepgistrationReportComponent {

  isLoading: boolean = false;

  // Filters and Report Inputs
  type: any;
  start_date = '';
  end_date = '';
  rep_name = '';
  off_rep_name = '';
  issue_cat = '';
  issue_date = '';
  newissuedatepp: any;

  // Report Data
  inDetailsRegReport: any[] = [];
  filteredinDetailsRegReport: any;

  // Totals
  issue_amt = 0;
  price = 0;
  issueCopies = 0;
  discount = 0;
  netamount = 0;
  gstamount = 0;
  remainingamt = 0;
  recivedamt = 0;

  rep_type: any;
  getdatabydep: any;

  constructor(
    private dialogref: MatDialogRef<RegistrationReportComponent>,
    private datePipe: DatePipe,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private service: DigisubservicesService
  ) {}

 ngOnInit(): void {
    this.type = this.data['type'];
      this.start_date = this.data['start_date'];
      this.end_date = this.data['end_date'];
      this.rep_name = this.data['rep_name'];
      this.off_rep_name = this.data['off_rep_name'];
      this.newissuedatepp = this.data['newissuedatepp'];
    
      this.issue_cat = this.data['issue_cat'] === undefined ? "ALL" : this.data['issue_cat'];
    
      // Extract only the date part (before first comma)
      const issueDateRaw = this.data['issueDates'];
      if (Array.isArray(issueDateRaw) && issueDateRaw.length > 0) {
        this.issue_date = issueDateRaw[0].split(',')[0];
      } else {
        this.issue_date = "ALL";
      }
    
      console.log("Final Payload Data:", {
        representativeId: this.rep_name,
        startDate: this.start_date,
        endDate: this.end_date,
        officeRepresentativeId: this.off_rep_name,
        issueNameId: this.issue_cat,
        issueSellerDate: this.issue_date
      });
  this.getRegoffwiseindetailReportData();
}

getRegoffwiseindetailReportData() {
  const request = {
    representativeId: this.rep_name,
    startDate: this.start_date,
    endDate: this.end_date,
    officeRepresentativeId: this.off_rep_name,
    issueNameId: this.issue_cat,
    issueSellerDate: this.issue_date
  };

  this.service.getIssueSellerRegoffwiseindetailReportList(request).subscribe(data => {
    this.filteredinDetailsRegReport = [];

      // Group by off_rep_name
      data.forEach(group => {
        const offRepName = group.off_rep_name || '';
        const advtData = group.rep_data.flatMap(rep => rep.advt_data || []);

        this.filteredinDetailsRegReport.push({
          off_rep_name: offRepName,
          advt_data: advtData
        });
      });

      this.calculateGroupAndGrandTotals();
    });
  }

calculateGroupAndGrandTotals() {
  this.issue_amt = this.price = this.issueCopies = this.discount =
  this.gstamount = this.netamount = this.remainingamt = this.recivedamt = 0;

  this.filteredinDetailsRegReport.forEach(report => {
    let group_issue_amt = 0, group_price = 0, group_copies = 0;
    let group_discount = 0, group_net_amt = 0, group_remaining = 0, group_received = 0;

    report.advt_data.forEach(item => {
      const totalAmt = parseFloat(item.total_amt) || 0;
      const price = parseFloat(item.issue_amt) || 0;
      const copies = parseFloat(item.issue_copies) || 0;
      const discount = parseFloat(item.disc_amt) || 0;
      const netAmt = parseFloat(item.amount) || 0;
      const remaining = parseFloat(item.remaingamt) || 0;
      const received = totalAmt - remaining;

      group_issue_amt += totalAmt;
      group_price += price;
      group_copies += copies;
      group_discount += discount;
      group_net_amt += netAmt;
      group_remaining += remaining;
      group_received += received;

      this.issue_amt += totalAmt;
      this.price += price;
      this.issueCopies += copies;
      this.discount += discount;
      this.netamount += netAmt;
      this.remainingamt += remaining;
      this.recivedamt += received;
    });

    report.group_issue_amt_total = group_issue_amt;
    report.group_price_total = group_price;
    report.group_copies_total = group_copies;
    report.group_discount_total = group_discount;
    report.group_net_amt_total = group_net_amt;
    report.group_remaining_total = group_remaining;
    report.group_received_total = group_received;
  });
}

exportExcel(fileName: string) {
  let element = document.getElementById('print-section');
  const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
  const wb: XLSX.WorkBook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
  XLSX.writeFile(wb, `${fileName}.xlsx`);
}



  print() {
    const originalTitle = document.title;
    document.title = '';

    const style = document.createElement('style');
    style.innerHTML = `
      @media print {
        @page {
          size: A4;
          margin: 10mm;
        }
        .print-header {
          text-align: center;
          font-size: 16px;
          font-weight: bold;
          margin-bottom: 10px;
        }
        .print-footer {
          position: fixed;
          bottom: 10px;
          left: 0;
          right: 0;
          text-align: center;
          font-size: 12px;
          color: gray;
        }
        .print-footer::after {
          content: "Page " counter(page) " of " counter(pages);
        }
        .no-print {
          display: none !important;
        }
      }
    `;
    document.head.appendChild(style);

    setTimeout(() => {
      const printTrigger = document.getElementById('print-button');
      if (printTrigger) (printTrigger as HTMLElement).click();
      document.title = originalTitle;
    }, 500);
  }

  assignoffwithtype() {
    this.rep_type = 'issue';
    this.service.getListofassignrep(this.rep_type).subscribe(data => {
      this.getdatabydep = data;
      console.log('Assigned Reps:', this.getdatabydep);
    });
  }

}
